import { PageControlState, } from '@kubit/web-ui-components/pageControl/types';
import { pageControlCommonStateStyles, pageControlCommonStyles } from '../commonStyles';
import { PageControlVariant } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [PageControlVariant.REGULAR]: {
            isBullet: true,
            ...pageControlCommonStyles(FOUNDATIONS, {}),
            [PageControlState.CURRENT]: {
                pageDot: {
                    ...pageControlCommonStateStyles(FOUNDATIONS, {
                        background_color: FOUNDATIONS.color_exception_secondary_bg_50,
                        height: FOUNDATIONS.size_75,
                        width: FOUNDATIONS.size_75,
                    }),
                },
            },
            [PageControlState.DEFAULT]: {
                pageDot: {
                    ...pageControlCommonStateStyles(FOUNDATIONS, {
                        background_color: FOUNDATIONS.color_comp_navigation_pagecontrol_default_icon,
                        border_width: FOUNDATIONS.border_50,
                        border_color: FOUNDATIONS.color_comp_navigation_pagecontrol_default_border,
                        opacity: FOUNDATIONS.alpha_400,
                        height: FOUNDATIONS.size_50,
                        width: FOUNDATIONS.size_50,
                    }),
                },
            },
            [PageControlState.LAST]: {
                pageDot: {
                    ...pageControlCommonStateStyles(FOUNDATIONS, {
                        background_color: FOUNDATIONS.color_comp_navigation_pagecontrol_lastpage_icon,
                        opacity: FOUNDATIONS.alpha_400,
                        height: FOUNDATIONS.size_38,
                        width: FOUNDATIONS.size_38,
                    }),
                },
            },
        },
    };
};
//# sourceMappingURL=regular.js.map